import { Container } from '@cgs/wge';
import { GAME_STATE_MACHINE_PROVIDER_TOKEN, IGameStateMachineProvider } from '@cgs/machines';
import { TRIFECTA_SDK_ADAPTER_TOKEN, TrifectaSDKAdapter } from '../../../sdk/trifecta-sdk.adapter';
import {
  TRIFECTA_START_PAGE_COMPONENT_TOKEN,
  TrifectaStartPageComponent,
} from './trifecta-start-page.component';

export const TRIFECTA_GAME_OVERLAY_INIT_COMPONENT_TOKEN = Symbol(
  'TRIFECTA_GAME_OVERLAY_INIT_COMPONENT_TOKEN'
);

export class TrifectaGameOverlayInitComponent {
  constructor(protected readonly container: Container) {}

  public async handleShowOverlay(): Promise<void> {
    const startPage = this.container.resolve<TrifectaStartPageComponent>(
      TRIFECTA_START_PAGE_COMPONENT_TOKEN,
      { optional: true }
    );

    if (startPage) {
      await startPage.onClose.toPromise();
    } else {
      const gsm = this.container.resolve<IGameStateMachineProvider>(
        GAME_STATE_MACHINE_PROVIDER_TOKEN
      ).gameStateMachine;
      await gsm.init.entered.first;
    }

    this.container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN).showContainer();
  }
}
